// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"177":"home","966":"dashboard"}[chunkId] + "." + {"177":"f645fb03","966":"02c9de99"}[chunkId] + ".js";
};